import { render, staticRenderFns } from "./DepositMoneyRegistration.vue?vue&type=template&id=b357f4aa&scoped=true&"
import script from "./DepositMoneyRegistration.vue?vue&type=script&lang=js&"
export * from "./DepositMoneyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DepositMoneyRegistration.vue?vue&type=style&index=0&id=b357f4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b357f4aa",
  null
  
)

export default component.exports